import React from 'react';
import { BarLoader } from 'react-spinners';
import './LoadingContainer.css';

const LoadingContainer = () => {
    return (
    <div className="loading-wrapper">
        <BarLoader
            color="#F0CB46"
            height={3}
            width={150}
        />
    </div>
    );
};

export default LoadingContainer;
